module.exports = __webpack_public_path__ + "img/0A.f59192bb.png";